import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "../../styles/components/ui/_downloading-modal.scss";

export default function DownloadingModal({ open, title, body }) {
    const root = typeof document !== "undefined" ? document.body : null;
    const prevFocusRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        prevFocusRef.current = document.activeElement;
        return () => prevFocusRef.current?.focus?.();
    }, [open]);

    if (!open || !root) return null;

    return createPortal(
        <div className="dm" role="dialog" aria-modal="true" aria-label={title}>
            <div className="dm__card" role="document">
                <div className="dm__spinner" aria-hidden="true" />
                <div className="dm__text">
                    <p className="dm__title">{title}</p>
                    {body ? <p className="dm__body">{body}</p> : null}
                </div>
            </div>
        </div>,
        root
    );
}

